import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer-listagem-busca',
  standalone: true,
  templateUrl: './footer-listagem-busca.component.html',
  styleUrls: ['./footer-listagem-busca.component.scss'],
})
export class FooterListagemBuscaComponent implements OnInit {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  userId: string;

  @Input() moduloIDs: { [key: string]: number };
  @Input() idSelecionado: number | null;

  constructor() {
    this.userId = localStorage.getItem('userId');
  }

  ngOnInit() {}

  getUpgradeLink(): string {
    if (this.userId === '233278' || this.userId === '235633') {
      return 'https://rededeobras.construmarket.com.br/fichas-de-prospeccao?utm_source=admin-rdo&utm_medium=teste&utm_campaign=teste_gratuito';
    }

    switch (this.idSelecionado) {
      case this.moduloIDs['Imobiliario']:
        return 'https://rededeobras.construmarket.com.br/de-um-upgrade-no-seu-plano-imobiliario/?utm_source=plg-rededeobras&utm_medium=plg-rededeobras&utm_campaign=upgrade-rededeobras-imobili%C3%A1rio+&utm_id=upgrade-rededeobras-imobili%C3%A1rio+';
      case this.moduloIDs['Industrial']:
        return 'https://rededeobras.construmarket.com.br/de-um-upgrade-no-seu-plano-industrial/?utm_source=plg-rededeobras&utm_medium=plg-rededeobras&utm_campaign=upgrade-rededeobras-industrial+&utm_id=upgrade-rededeobras-industrial+';
      case this.moduloIDs['Edificacoes']:
        return 'https://rededeobras.construmarket.com.br/de-um-upgrade-no-seu-plano-edificacoes/?utm_source=plg-rededeobras&utm_medium=plg-rededeobras&utm_campaign=upgrade-rededeobras-edificacoes&utm_id=upgrade-rededeobras-edificacoes';
      case this.moduloIDs['Infraestrutura']:
        return 'https://rededeobras.construmarket.com.br/de-um-upgrade-no-seu-plano-infra/?utm_source=plg-rededeobras&utm_medium=plg-rededeobras&utm_campaign=upgrade-rededeobras-infra+&utm_id=upgrade-rededeobras-infra+';

      default:
        return 'https://app.rededeobras.com.br/';
    }
  }

  getBannerText(): string {
    switch (this.idSelecionado) {
      case this.moduloIDs['Imobiliario']:
        return `Com <span class="bold">+10.000 im\u00F3veis</span> cadastrados no
                <span class="bold">m\u00F3dulo imobili\u00E1rio</span>,<br />
                voc\u00EA tem acesso a dados qualificados de diversas propriedades <br />
                da sua regi\u00E3o com os contatos de decisores.`;

      case this.moduloIDs['Industrial']:
        return `Com <span class="bold">+6.000 obras</span> mapeadas no
                <span class="bold">m\u00F3dulo industrial</span>,<br />
                voc\u00EA tem acesso a dados qualificados de diversas obras <br />
                da sua regi\u00E3o com os contatos de decisores.`;

      case this.moduloIDs['Edificacoes']:
        return `Com <span class="bold">+8.000 projetos</span> cadastrados no
                <span class="bold">m\u00F3dulo edifica\u00E7\u00F5es</span>,<br />
                voc\u00EA tem acesso a dados qualificados de diversas constru\u00E7\u00F5es
 <br />
                da sua regi\u00E3o com os contatos de decisores.`;

      case this.moduloIDs['Infraestrutura']:
        return `Com <span class="bold">+5.000 obras</span> mapeadas no
                <span class="bold">m\u00F3dulo infraestrutura</span>,<br />
                voc\u00EA tem acesso a dados qualificados de diversas obras <br />
                da sua regi\u00E3o com os contatos de decisores.`;

      default:
        return `Com <span class="bold">dados exclusivos</span> da Rede de Obras,<br />
                voc\u00EA tem acesso a informa\u00E7\u00F5es
 qualificadas de diversas obras <br />
                da sua regi\u00E3o com os contatos de decisores.`;
    }
  }
}
